import { render } from "./StaffProfile.vue?vue&type=template&id=1ea0af40"
import script from "./StaffProfile.vue?vue&type=script&lang=js"
export * from "./StaffProfile.vue?vue&type=script&lang=js"
script.render = render

export default script